// extracted by mini-css-extract-plugin
export default {"Box":"tokenized-query-container-module__Box--I6zeN"};